import { sdkRequest } from '@eventbrite/http';
import { CurrencySettingsDTO } from '../types';

export const getCurrencySettings = (): Promise<CurrencySettingsDTO> => {
    const options = {
        method: 'GET',
    };

    return sdkRequest(`/checkout_settings/countries_currencies/`, options);
};
